export default class ApiError extends Error {
  constructor(message, status = 200) {
    super(message);
    this.status = status;
  }
}
